export const PROMOTIONS_TYPE = 'PROMOTIONS';
export const PROMOTIONS_TITLE = 'The Home Depot';
export const LOCAL_AD_TYPE = 'LOCAL_AD';
export const LOCAL_AD_TITLE = 'Local Ad';
export const PRO_TYPE = 'PRO';
export const PRO_TITLE = 'Pro Communications';
export const SBOTD_TYPE = 'SPECIAL_BUY_OF_THE_DAY';
export const SBOTD_TITLE = 'Special Buy of the Day';
export const PHONE_TITLE = 'Phone Calls';
export const PHONE_TYPE = 'DEFAULT';
// region implicit opt in section
export const RETARGETING_TYPE = 'RETARGETING';
export const SURVEYS_TYPE = 'SURVEYS';
export const SURVEYS_TITLE = 'Surveys';
// endregion

export const typeToTitleMap = {
  [PRO_TYPE]: PRO_TITLE,
  [PROMOTIONS_TYPE]: PROMOTIONS_TITLE,
  [LOCAL_AD_TYPE]: LOCAL_AD_TITLE,
  [SBOTD_TYPE]: SBOTD_TITLE,
  [PHONE_TYPE]: PHONE_TITLE,
  [SURVEYS_TYPE]: SURVEYS_TITLE,
};

export const emailTableHeaders = {
  name: 'Email',
  icon: 'https://assets.thdstatic.com/images/v1/email-icon-gray.svg',
  width: '25px',
  marginRight: '8px'
};

export const initialEmailTableData = () => {
  return {
    [PROMOTIONS_TITLE]: {
      subText: 'Get exclusive savings, services, project ideas and more delivered to your inbox.',
      value: 'N',
      type: PROMOTIONS_TYPE
    },
    [PRO_TITLE]: {
      subText: `Get jobs done right with up-to-date special offers, savings,
      pro benefits and more, at your fingertips.`,
      value: 'N',
      type: PRO_TYPE
    },
    [SBOTD_TITLE]: {
      subText: 'Sign up now to get one-day only savings sent right to you daily.',
      value: 'N',
      type: SBOTD_TYPE
    },
    [LOCAL_AD_TITLE]: {
      subText: 'Stay in the know about the latest savings and updates from your local store, right to your inbox.',
      value: 'N',
      type: LOCAL_AD_TYPE
    }
  };
};

export const initialSurveyTableData = () => {
  return {
    [SURVEYS_TITLE]: {
      subText: 'Provide customer feedback by subscribing to survey emails.',
      value: 'Y',
      type: SURVEYS_TYPE,
    }
  };
};

export const phoneTableHeaders = {
  name: 'Text',
  icon: 'https://assets.thdstatic.com/images/v1/text-icon-gray.svg',
  width: '14px',
  marginRight: '8px'
};

export const initialPhoneTableData = () => {
  return {
    [PROMOTIONS_TITLE]: {
      subText: 'Get exclusive savings, services, project ideas and more delivered to your inbox.',
      value: 'N',
      type: PROMOTIONS_TYPE,
      isPending: false,
    },
    [PRO_TITLE]: {
      subText: `Get jobs done right with up-to-date special offers, savings, pro benefits and
       more, at your fingertips.`,
      value: 'N',
      type: PRO_TYPE,
      isPending: false,
    }
  };
};
export const initialSmsPhoneTableData = () => {
  return {
    [PROMOTIONS_TITLE]: {
      subText: 'Get exclusive savings, services, project ideas and more delivered to your inbox.',
      value: 'N',
      type: PROMOTIONS_TYPE,
      isPending: false,
    },
    [PRO_TITLE]: {
      subText: `Get jobs done right with up-to-date special offers, savings, pro benefits and
       more, at your fingertips.`,
      value: 'N',
      type: PRO_TYPE,
      isPending: false,
    },
    [PHONE_TITLE]: {
      subText: 'Hear from The Home Depot about products, services, and special offers by phone call.',
      value: 'Y',
      type: PHONE_TYPE
    }
  };
};
